import { AppGetters } from './types'

const getters: AppGetters = {
  getApps(state) {
    return state.apps
  },
  getSelectedAppPosts(state) {
    return state.selectedAppPosts
  },
  getSelectedApp(state) {
    return state.selectedApp
  },
}

export default getters
